import React from 'react';
import ReactTooltip from "react-tooltip";

import ApiUtils from '../util/ApiUtils';
import '../styles/section.css';
import '../styles/tables.css';
import RelayerInline from './RelayerInline';
import PageHeader from '../components/PageHeader';
import Utilities from '../util/Utilities';
import BreadcrumbUtils from '../util/BreadcrumbUtils';

class Relayer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      relayer: {},
      addresses: [],
      notification: {},
      width: window.innerWidth,
      size: 10,
      responsive: true,
      isLoading: true,
    }

    this.updateDimensions = this.updateDimensions.bind(this);
  }

  updateDimensions() {
    this.setState({width: window.innerWidth});
  }

  componentWillMount() {
    this.updateDimensions();
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateDimensions);
  }

  async componentDidMount() {
    window.addEventListener("resize", this.updateDimensions);

    let url = "relayers";
    if (this.props.match && this.props.match.params.identity) {
      let identity = this.props.match.params.identity;
      url += "?identity=" + identity;
    }

    const allData = await ApiUtils.get(url);
    if (allData) {
      // console.log(allData["addresses"]);
      this.setState({"relayer": allData["relayers"][0], "addresses": Utilities.addIndex(allData["addresses"]),
        "notification": allData["notification"],
        isLoading: false});
    }
  }

  render() {
    if (this.state.isLoading) {
      return <div>Loading</div>;
    }

    return (
      <div>
        {BreadcrumbUtils.getRelayersBreadCrumb()}
        <p/>
        <PageHeader title={"Interchain Relayer - " + this.state.relayer.name} thisObj={this} disableStakeFormatter={true} />
        <ReactTooltip id="main" place="top" type="dark" effect="float" multiline={true} />
        <RelayerInline relayer={this.state.relayer} addresses={this.state.addresses} />
      </div>
    );
  }
}

export default Relayer;
